export default __webpack_public_path__ + "static/media/dashboard-hero.40479d44.svg";